import i18n from '../../i18n'

export default function ({ zxcvbnResult, password, score, minScore, minLength = 12 }) {
  let dataStrength = -1
  let feedback = null

  if (zxcvbnResult !== null) {
    feedback = zxcvbnResult.feedback
  }

  if (password.length <= 0) {
    dataStrength = -1
  } else if (password.length > 0 && password.length < minLength) {
    dataStrength = 0
  } else {
    dataStrength = (password.length === 0 && score === 0) ? -1 : score
  }

  let passResult = ''
  const allSuggestions = []
  let suggestionResult = ''

  if (dataStrength === 0) {
    passResult = i18n.profile.password.passwordStrengthMeter.tooltip_passwd_compromised
    if ((password.length > 0 && password.length < minLength)) {
      passResult = i18n.profile.password.passwordStrengthMeter.tooltip_passwd_too_short
    }
  } else if (dataStrength > 0 && dataStrength < minScore) {
    if (feedback && feedback.warning !== '') {
      passResult = feedback.warning
    }

    if (feedback && feedback.suggestions.length > 0) {
      suggestionResult = `${i18n.profile.password.passwordStrengthMeter.tooltip_suggestions}:`
      feedback.suggestions.forEach((suggestion) => {
        allSuggestions.push(suggestion)
      })
    }
  } else if (dataStrength >= minScore) {
    passResult = i18n.profile.password.passwordStrengthMeter.tooltip_passwrd_meet_standards
  }

  return { dataStrength, passResult, allSuggestions, suggestionResult }
}
